const SeoTitles = {
    Home: 'CRN Heritage',
};

export default SeoTitles;